import { AppShell } from "@/components/AppShell";
import { AUSWERTUNGEN_SECTION_SUBTITLES } from "@/lib/auswertungenNav";
import { OfferStatisticsReport } from "@/pages/auswertungen/OfferStatisticsReport";

export function OfferStatisticsPage() {
  return (
    <AppShell
      title="Auswertungen"
      subtitle={AUSWERTUNGEN_SECTION_SUBTITLES["offer-statistics"]}
    >
      <OfferStatisticsReport />
    </AppShell>
  );
}
